<template>
	<div class="challenge layout-row layout-justify-center">
		<left-nav></left-nav>
		<router-view class="routerView"></router-view>
	</div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment-timezone";
import LeftNav from "@/components/challenge/LeftNav";
export default {
	components: {
		LeftNav
	},
	computed: {
		...mapState("user", [
			"userInfo"
		])
	},
	beforeRouteEnter(to, from, next) {
		// 如果超過３個月沒有更新個資，強制修改個資
		next(vm => {
			if (to.path != "/dfcchallenge/person-info"
				&& moment(vm.userInfo.update_time)
					.add(6, "months")
					.tz("Asia/Taipei")
					.valueOf() <= Date.now()) {
				next("/dfcchallenge/person-info?message=已超過３個月沒有更新資料，請確認是否為最新，並按下儲存鍵！")
			} else if (to.path != "/dfcchallenge/person-info"
				&& moment(vm.userInfo.update_time).valueOf() < moment("2025-03-27 13:40").valueOf()) {
				next("/dfcchallenge/person-info?message=親愛的輔導員您好，提醒您，因為後台個人資料欄位有異動， 邀請您前往個人資料頁面更新～\n並邀請您確認資訊是否為最新後按下儲存鍵！謝謝您！")
			} else next();
		})
	},
	beforeRouteUpdate(to, from, next) {
		// 如果超過３個月沒有更新個資，強制修改個資
		if (to.path != "/dfcchallenge/person-info"
			&& moment(this.userInfo.update_time)
				.add(6, "months")
				.tz("Asia/Taipei")
				.valueOf() <= Date.now()) {
			next("/dfcchallenge/person-info?message=已超過３個月沒有更新資料，請確認是否為最新，並按下儲存鍵！")
		} else next();
	}
};
</script>

<style lang="scss" scoped>
.challenge {
	min-width: 1000px;
	.routerView {
		min-width: 785px;
	}
}
</style>
